$(document).ready(function () {
    $('.sortable').nestedSortable({
        disableNesting: 'no-nest',
        forcePlaceholderSize: true,
        handle: 'div',
        helper: 'clone',
        items: 'li',
        maxLevels: 2,
        opacity: .6,
        placeholder: 'placeholder',
        revert: 250,
        rootID: 0,
        tabSize: 30,
        tolerance: 'pointer',
        toleranceElement: '> div',
        update: function (event) {
            var items = [];
            $.each($('ol.sortable').nestedSortable('toArray', {startDepthCount: 0}), function (i, item) {
                var itm = {};
                itm.index = item.item_id;
                itm.lft = item.left;
                itm.rgt = item.right;
                itm.lvl = item.depth;
                itm.parent = item.parent_id;

                items[item.item_id] = itm;
            });

            $.ajax({
                type: 'post',
                url: '/core/menu/item-sort?_ch=' + $('#_ch').val(),
                data: {items: items},
                dataType: "json"
            });
        }
    });

    // DRAG and DROP
    $("#sections li").draggable({
        revert: true
    });

    $("#items-drop").droppable({
        tolerance: 'touch',
        over: function () {
            $(this).addClass('over');
        },
        out: function () {
            $(this).removeClass('over');
        },
        drop: function (event, ui) {
            $(this).removeClass('over');
            var index = $('#items li').length + 1;
            var id = $(ui.draggable).attr('data-section-id');
            var name = $(ui.draggable).html();
            var html = '';
            var classNoNest = '';

            if (id > 0) {
                classNoNest = ' class="no-nest"';
            }

            html += '<li id="items-' + index + '"' + classNoNest + '>';
            html += '    <div>';
            html += '        <button class="item-icon item-delete btn btn-sm btn-danger" data-item-index="' + index + '"><i class="fas fa-fw fa-trash"></i></button>';

            if (id == 0) {
                html += '        <button class="item-icon item-edit btn btn-sm btn-primary" data-item-index="' + index + '"><i class="fas fa-fw fa-pencil"></i></button>';
            }

            html += '        <span id="items-' + index + '-text" class="item-text">' + name + '</span>';
            html += '    </div>';
            html += '</li>';

            $('#items ol:first').append(html);

            var items = $('ol.sortable').nestedSortable('toArray', {startDepthCount: 0});

            $.ajax({
                type: 'post',
                url: '/core/menu/item-add?_ch=' + $('#_ch').val(),
                data: {
                    index: items[index]['item_id'],
                    name: name,
                    section: id,
                    lft: items[index]['left'],
                    lftRoot: items[0]['left'],
                    rgt: items[index]['right'],
                    rgtRoot: items[0]['right'],
                    lvl: items[index]['depth'],
                    parent: items[index]['parent_id']
                },
                dataType: "json"
            });
        }
    });

    // ===== ITEM =====

    // Edit item
    $('#items').on('click', '.item-edit', function (e) {
        e.preventDefault();

        item(this);
    });

    // Delete item
    $('#items').on('click', '.item-delete', function (e) {
        e.preventDefault();

        itemDelete(this);
    });
});

function dump(arr, level) {
    var dumped_text = "";
    if (!level) level = 0;

    //The padding given at the beginning of the line.
    var level_padding = "";
    for (var j = 0; j < level + 1; j++) level_padding += "    ";

    if (typeof(arr) == 'object') { //Array/Hashes/Objects
        for (var item in arr) {
            var value = arr[item];

            if (typeof(value) == 'object') { //If it is an array,
                dumped_text += level_padding + "'" + item + "' ...\n";
                dumped_text += dump(value, level + 1);
            } else {
                dumped_text += level_padding + "'" + item + "' => \"" + value + "\"\n";
            }
        }
    } else { //Strings/Chars/Numbers etc.
        dumped_text = "===>" + arr + "<===(" + typeof(arr) + ")";
    }
    return dumped_text;
}

function item(element) {
    var index = $(element).attr('data-item-index');
    var url = '/core/menu/item-edit?_ch=' + $('#_ch').val() + '&index=' + index;

    $(document).load(url, function (form) {
        Lemo_Modal.setTitle('Add item');
        Lemo_Modal.setContent(form);
        Lemo_Modal.addButton('save', 'Save', 'btn btn-primary', function () {
            var name = $('#dialogBody').find('#name').val();

            $.ajax({
                type: 'post',
                url: url,
                data: $('#dialogBody :input').serialize(),
                dataType: "json",
                success: function (data) {
                    $('#items-' + index + '-text').text(name);
                    Lemo_Alert.addSuccess('Item has been successfully updated');
                    Lemo_Modal.close();
                },
                error: function (html) {
                    Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly');

                    $('#dialogBody').html(html.responseText);
                }
            });
        });
        Lemo_Modal.addButton('cancel', translate('Cancel'), 'btn btn-default', function () {
            Lemo_Modal.close();
        });
        Lemo_Modal.build();

        // Change item type
        $('#dialogBody').on('change', '#type', function (e) {
            itemChangeType(this.value);
        });
    });
}

function itemDelete(element) {
    var index = $(element).attr('data-item-index');
    var url = '/core/menu/item-sort?_ch=' + $('#_ch').val() + '&index=' + index;

    Lemo_Modal.setTitle('Remove item');
    Lemo_Modal.setContent('<p class="text">' + translate('Do you really want remove selected menu item?') + '</p>');
    Lemo_Modal.addButton('remove', 'Remove', 'btn btn-primary', function () {
        $(element).parent().parent().remove();

        var items = [];
        $.each($('ol.sortable').nestedSortable('toArray', {startDepthCount: 0}), function (i, item) {

            var itm = {};
            itm.index = item.item_id;
            itm.lft = item.left;
            itm.rgt = item.right;
            itm.lvl = item.depth;
            itm.parent = item.parent_id;

            items[i] = itm;
        });

        $.ajax({
            type: 'post',
            url: url,
            data: {items: items},
            dataType: "json",
            success: function (data) {
                Lemo_Modal.close();
            }
        });
    });
    Lemo_Modal.addButton('cancel', translate('Cancel'), 'btn btn-default', function () {
        Lemo_Modal.close();
    });
    Lemo_Modal.build();
}

function itemChangeType(value) {
    var dialogBody = $('#dialogBody');
    if (value == 'url') {
        dialogBody.find('#form-group-url, #form-group-target').removeClass('d-none');
        dialogBody.find('#url').val('http://');
    } else {
        dialogBody.find('#form-group-url, #form-group-target').addClass('d-none');
        dialogBody.find('#url').val('');
    }
}
